import React from 'react';
import { generatePath } from 'react-router';
import { RoutedComponentProps } from 'src/app-routes';
import { ShopFeature } from 'src/app-types';
import { ProductsSection } from './components/ProductsSection/ProductsSection';
import { Dispatch } from 'src/components-dummy/types';
import {
  LastUserLocation,
  LastUserLocationProps,
} from './components/LastUserLocation/LastUserLocation';
import { LinkedinSection } from './components/LinkedinSection/LinkedinSection';
import { WrapperSection } from './Home.styles';
import { SectionWithTitle } from './components/SectionWithTitle/SectionWithTitle';
import { IInsightsShopMetadataAPIModel } from 'src/services';
import { HomeWidget } from '../Analytics/components/HomeWidget/HomeWidget';
import { ExperimentsHomeWidget } from '../ExperimentsHomeWidget';

export interface HomeContentProps extends RoutedComponentProps, LastUserLocationProps {
  shopId: number;
  enabledShopFeatures: Set<ShopFeature>;
  insightsShopMetadata: IInsightsShopMetadataAPIModel;
  isUserPermittedForAnalyticsHomeWidget: boolean;
  isExperimentsFeatureEnabled: boolean;
  isUserPermittedForExperimentsHomeWidget: boolean;
  dispatch: Dispatch;
}

export const HomeContent = ({
  shopId,
  permittedRouteMap,
  dispatch,
  lastVisitedURL,
  isUserPermittedForAnalyticsHomeWidget,
  isExperimentsFeatureEnabled,
  isUserPermittedForExperimentsHomeWidget,
}: HomeContentProps): JSX.Element => {
  const experimentsRoute = permittedRouteMap.experiments?.path
    ? generatePath(permittedRouteMap.experiments.path, { shopId })
    : undefined;
  const abTestDashboardRoute = permittedRouteMap.abTestDashboard?.path;
  const experimentWizardRoute = permittedRouteMap.experimentWizard?.path;
  const dataFieldsRoute = permittedRouteMap.dataFields?.path;

  return (
    <>
      <LastUserLocation
        lastVisitedURL={lastVisitedURL}
        dispatch={dispatch}
        permittedRouteMap={permittedRouteMap}
      />
      <WrapperSection>
        {isUserPermittedForAnalyticsHomeWidget && (
          <HomeWidget shopId={shopId} dispatch={dispatch} permittedRouteMap={permittedRouteMap} />
        )}
        <SectionWithTitle title='Quick Links'>
          <ProductsSection
            shopId={shopId}
            permittedRouteMap={permittedRouteMap}
            dispatch={dispatch}
          />
        </SectionWithTitle>
        {isExperimentsFeatureEnabled && isUserPermittedForExperimentsHomeWidget && (
          <SectionWithTitle title='Insights'>
            <ExperimentsHomeWidget
              shopId={shopId}
              experimentsRoute={experimentsRoute}
              abTestDashboardRoute={abTestDashboardRoute}
              experimentWizardRoute={experimentWizardRoute}
              dataFieldsRoute={dataFieldsRoute}
            />
          </SectionWithTitle>
        )}
        <LinkedinSection />
      </WrapperSection>
    </>
  );
};
